<template>
	<div class="navigation-mobile">
		<div class="top-block open" @click="openMenu">
			{{ menuData.mobileMenu.text }}
			<div class='lines'>
				<span class='one'></span>
				<span class='two'></span>
				<span class='three'></span>
			</div>
		</div>
		<ul class="menu-level-one active">
			<li v-for="element in menuData.menu">
				<a :href="element.href" class="level-one-link"
				   @click="openSubmenu($event, !!element.submenu)">
					{{ element.text }}
					<svg v-if="element.submenu" width="12px" height="12px">
						<use xlink:href="#svg-arrow-down"></use>
					</svg>
				</a>
				<ul class="sub-menu" v-if="element.submenu">
					<li class="back" @click="backSubMenu($event)">
						{{ menuData.backText.text }}
					</li>
					<li v-for="el in element.submenu">
						<a :href="el.href" @click="openSubmenu($event, !!el.submenu)">
							<div class="icon" v-if="el.image" v-html="el.image"></div>
							{{ el.text }}
							<svg v-if="el.submenu" width="12px" height="12px">
								<use xlink:href="#svg-arrow-down"></use>
							</svg>
						</a>
						<ul v-if="el.submenu" class="sub-menu">
							<li class="back" @click="backSubMenu($event)">
								{{ menuData.backText.text }}
							</li>
							<li v-for="element in el.submenu">
								<a :href="element.href">
									<div class="icon" v-if="el.image" v-html="element.image"></div>
									{{ element.text }}
								</a>
							</li>
						</ul>
					</li>
				</ul>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'navigation-mobile',
		props: ['dataParams'],
		data() {
			return{
				menuData: this.dataParams
			}
		},
		methods: {
			openMenu(e) {
				e.currentTarget.classList.toggle('open');
				$(e.currentTarget).siblings('.menu-level-one').toggleClass('active');
			},
			openSubmenu(e, submenu) {
				if(submenu) {
					e.preventDefault();
					// e.stopPropagation();
					$(e.currentTarget).siblings('.sub-menu').addClass('visible');
				};
			},
			backSubMenu(e) {
				$(e.currentTarget).closest('.sub-menu').removeClass('visible');
			}
		}
	}
</script>

<style lang="scss">
	@import "scss/wanted";
	.navigation-mobile {
		position: relative;
		/*height: 55px;*/
		margin-bottom: 2px;
		.top-block {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height: 55px;
			background-color: var(--bg-color);
			padding: 0 5px 0 15px;
			font-size: 14px;
			color: var(--ct-color);
			font-weight: 600;
			border-radius: .25rem;
			.lines {
				@include flexbox;
				@include align-items(center);
				@include align-content(center);
				@include justify-content(center);
				@include flex-wrap(wrap);
				width: rem(40);
				height: rem(34);
				@include single-transition;

				span {
					display: block;
					width: 100%;
					height: 2px;
					margin: 0 0 3px;
					position: relative;
					@include single-transition;

					&:before {
						content: '';
						display: inline-block;
						height: 2px;
						width: rem(18);
						background-color: #fff;
						@include m_up{
							background-color: #6E7175;
						};
						position: absolute;
						top: 0;
						left: calc(50% - #{rem(18/2)});
					}

					&:last-child {
						margin: 0;
					}
				}
			}
			&.open {
				.lines {
					@include translateX(2px);

					span {
						&:before {
							// background-color: #263C46;
						}

						&.one {
							@include transform(rotate(45deg) translateX(2px) translateY(5px));
						}

						&.two {
							opacity: 0;
						}

						&.three {
							@include transform(rotate(-45deg) translateX(2px) translateY(-5px));
						}
					}
				}
			}
			margin-bottom: 2px;
		};
		.menu-level-one {
			box-shadow: 0 10px 20px 0 rgba(0,0,0,.5);
			border-top-width: 4px;
			border-top-style: solid;
			border-top-color: var(--bg-color);

			width: 300px;
			position: absolute;
			z-index: 30;
			background-color: #fff;
			transform: translateY(10px);
			opacity: 0;
			pointer-events: none;
			transition: all .3s ease 0ms;
			left: 0;
			right: 0;
			&.active {
				transform: translateY(0);
				opacity: 1;
				pointer-events: auto;
				touch-action: auto;
				width: 100%;
			}
			li {
				a {
					display: flex;
					align-items: center;
					&.level-one-link{
						justify-content: center;
						height: 58px;
					}
					& > svg {
						margin-left: 5px;
					}
				}
				&:not(:last-child) a.level-one-link{
					border-bottom: 1px solid #202020;
				}
			}
			.sub-menu {
				z-index: 31;
				background-color: #fff;
				opacity: 0;
				pointer-events: none;
				transition: all .2s ease 0ms;
				position: absolute;
				top: 0;
				left: 0;
				border-top-color: var(--bg-color);
				transform: translateX(-100%);
				width: 100%;
				height: 100%;
				padding: 15px 30px 0px;
				overflow-y: auto;
				&.visible {
					transform: translateY(0);
					opacity: 1;
					pointer-events: auto;
					touch-action: auto;
					transition: all .4s ease .3s;
				}
				.back{
					position: relative;
					display: flex;
					align-items: center;
					padding-left: 15px;
					&:before {
						position: absolute;
						left: 0px;
						top: calc(50% - 7px);
						background-image: url(../img/arrmenu.svg);
						width: 15px;
						height: 15px;
						content: "";
						background-size: 15px;
						transform: rotate(180deg);
						transition: all .3s ease;
					}
				}
				li {
					height: 36px;
					a{
						.icon {
							margin-right: 10px;
							flex-shrink: 0;
							display: flex;
							align-items: center;
							svg {
								width: 15px;
								height: 15px;
								fill: var(--bg-color);
							}
						}
					}
				}
			}
		};
	}
</style>


// WEBPACK FOOTER //
// navidation-mobile.vue?5c4cfeee